import { useEffect, useRef, useState } from 'react';

export default function useInView(options = {}) {
	const ref = useRef(null);
	const [isInView, setIsInView] = useState(false);

	useEffect(() => {
		const element = ref.current;
		if (!element) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				setIsInView(entry.isIntersecting);
			},
			{
				root: null,
				threshold: 0.3, // 30% visible
				...options
			}
		);

		observer.observe(element);

		return () => {
			observer.unobserve(element);
		};
	}, [options]);

	return [ref, isInView];
}
